module.exports = __webpack_public_path__ + "media/my_images/logo_b-fc35090de6fd2918ea03251db9a78eb2.svg";